var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer",attrs:{"id":"app-footer"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticStyle:{"height":"fit-content"}},[_c('div',{staticClass:"col-sm vp-footer",staticStyle:{"direction":"ltr"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" © Visipoint. ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }